export const fieldSectionsFromSectorsIndex = {
  13: 1,
  14: 2,
  15: 3,
  16: 4,
  9: 5,
  10: 6,
  11: 7,
  12: 8,
  5: 9,
  6: 10,
  7: 11,
  8: 12,
  1: 13,
  2: 14,
  3: 15,
  4: 16,
};

export const fieldSectorsFromSectionsIndex = {
  1: 13,
  2: 14,
  3: 15,
  4: 16,
  5: 9,
  6: 10,
  7: 11,
  8: 12,
  9: 5,
  10: 6,
  11: 7,
  12: 8,
  13: 1,
  14: 2,
  15: 3,
  16: 4,
};

export const rivalFieldSectionsFromSectionsIndex = {
  1: 16,
  2: 15,
  3: 14,
  4: 13,
  5: 12,
  6: 11,
  7: 10,
  8: 9,
  9: 8,
  10: 7,
  11: 6,
  12: 5,
  13: 4,
  14: 3,
  15: 2,
  16: 1,
};
